if(document.querySelector('.dashboard-rent')) {
    let selectedConf = 0
    let body = document.querySelector('.dashboard-body')
    let selectConfs = document.querySelector('.select-conf-wrapper')
    let confItems = document.querySelectorAll('.conf-card')
    let calendarWrapper = document.querySelector('.calendar-wrapper')
    let closeCalendar = document.querySelector('.close-calendar')
    let dayWrapper = document.querySelector('.day-planing')
    let closeDay = document.querySelector('.close-day-planing')
    let title = document.querySelector('.dashboard-header')
    let appendHours = document.querySelector('.append-hours')
    let hoursItems = document.querySelector('.day-planing-hours')
    let hoursTitle = document.querySelector('.day-planing-title')

    function updateHas() {
        let {has} = window
        let items = document.querySelectorAll('.item.day')

        for(let item of items) {
            item.classList.remove('has')
        }

        if(has.length) {
            for(let date of has) {
                let item = document.querySelector('.item.day[data-date="' + date + '"]')

                item.classList.add('has')
            }
        }
    }

    closeDay.addEventListener('click', () => {
        calendarWrapper.classList.add('show')
        selectConfs.classList.remove('show')
        dayWrapper.classList.remove('show')

        title.hide()
    })

    for(let item of confItems) {
        item.addEventListener('click', () => {
            let {id} = item.dataset
            calendarWrapper.classList.add('show')
            selectConfs.classList.remove('show')
            dayWrapper.classList.remove('show')

            title.hide()

            selectedConf = id
        })
    }

    closeCalendar.addEventListener('click', () => {
        calendarWrapper.classList.remove('show')
        dayWrapper.classList.remove('show')
        selectConfs.classList.add('show')

        title.show()
    })

    let prevMonth = document.querySelector('.prev-month')
    let nextMonth = document.querySelector('.next-month')
    let calendarDate = new Date()
    let year = calendarDate.getFullYear()
    let month = calendarDate.getMonth()

    let prev = () => {
        let date = new Date(calendarDate)
        let prev = new Date(date.getFullYear(), date.getMonth()-1, 1)

        calendarDate = prev.Ymd()
        printCalendar(prev.getFullYear(), prev.getMonth())
    }

    let next = () => {
        let date = new Date(calendarDate)
        let next = new Date(date.getFullYear(), date.getMonth()+1, 1)

        calendarDate = next.Ymd()

        printCalendar(next.getFullYear(), next.getMonth())
    }

    function printCalendar(year, month) {
        let now = new Date()
        let weeks = getWeeks(year, month + 1)
        let rows = []
        let append = document.querySelector('.calendar-body-rows')
        let monthsRu = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        let titleText = monthsRu[month] + ' ' + year
        let titleElement = document.querySelector('.calendar-title')
        let has = []

        titleElement.textContent = titleText
        rows.push(`
            <div class="calendar-row week">
                <div class="item week-item">ПН</div>
                <div class="item week-item">ВТ</div>
                <div class="item week-item">СР</div>
                <div class="item week-item">ЧТ</div>
                <div class="item week-item">ПТ</div>
                <div class="item week-item">СБ</div>
                <div class="item week-item">ВС</div>
            </div>
        `)

        for(let week of weeks) {
            let structure = []

            for(let item of week) {
                let classes = ['item', 'day']

                if(!item.current) {
                    classes.push('other-month')
                }

                if(has.indexOf(item.ymd) != -1) {
                    classes.push('has')
                }

                if(item.ymd == now.Ymd()) {
                    classes.push('current')
                }

                structure.push(`<div class="${classes.join(' ')}" data-date="${item.ymd}"><span>${item.date.getDate()}</span></div>`)
            }

            structure = `<div class="calendar-row days">${structure.join('')}</div>`
            rows.push(structure)
        }

        rows = rows.join('')

        append.innerHTML = rows

        let days = document.querySelectorAll('.item.day:not(.other-month)')

        if(days.length) {
            for(let day of days) {
                day.addEventListener('click', () => {
                    let {date} = day.dataset
                    let conf = selectedConf

                    calendarWrapper.classList.remove('show')
                    selectConfs.classList.remove('show')
                    dayWrapper.classList.add('show')
            
                    title.hide()

                    body.startLoading()

                    requestAxios('dayData', {date, conf}, (data) => {
                        let hours = Number(data.hours.left)
                        let selected = data.selected
                        let userId = data.user_id
                        body.stopLoading()

                        hoursTitle.textContent = new Date(date).dmY() + ' г.'

                        appendHours.textContent = hours

                        window.hours = hours

                        printHoursItems(date, selected, userId)
                    })
                })
            }
        }

        updateHas()
    }

    function getHas() {
        requestAxios('getHas', '', (res) => {
            window.has = res
            updateHas()
        })
    }

    printCalendar(year, month)

    function printHoursItems(date, selected, userId) {
        let from = 7
        let to = 22
        let structure = []

        console.log(selected);

        for(let i = from; i <= to; i++) {
            let next = (i + 1) < 10 ? '0' + (i + 1) : i + 1
            let key = i < 10 ? '0' + i : i
            let before = key + ':00'
            let after = next + ':00'
            let row = []

            for(let i = 0; i <= 1; i++) {
                let classes = ['hour-item']
                let mins = 30 * i
                let nextMins = '00'
                let nextHours = next

                if(!mins) {
                    mins = '00'
                    nextMins = 30
                    nextHours = key
                }

                let time = `${key}:${mins} - ${nextHours}:${nextMins}`

                let itemDate = date + ' ' + key + ':' + mins + ':00'

                if(selected[itemDate]) {
                    let selectedUser = selected[itemDate]
    
                    if(selectedUser == userId) {
                        classes.push('selected')
                    } else {
                        classes.push('disabled')
                    }
                }

                row.push(`<div class="${classes.join(' ')}" data-date="${itemDate}">${time} <div class="spinner"></div></div>`)
            }

            before = '<div class="label before">' + before + '</div>'
            after = i == to ? '<div class="label after">' + after + '</div>' : ''

            structure.push(`
                <div class="hour-row">
                    ${before}
                    ${row.join('')}
                    ${after}
                </div>
            `)
        }

        structure = structure.join('')
        hoursItems.innerHTML = structure

        let items = hoursItems.querySelectorAll('.hour-item:not(.disabled)')

        if(items.length) {
            for(let item of items) {
                item.addEventListener('click', () => {
                    if(!item.classList.contains('loading') && !item.classList.contains('disabled')) {
                        let send = true

                        if(!item.classList.contains('selected') && !hours) {
                            send = false
                        }

                        if(send) {
                            let {date} = item.dataset
                            let conf = selectedConf
                            let data = {date, conf}
    
                            item.classList.add('loading')
    
                            requestAxios('selectDay', data, (data) => {
                                let hours = Number(data.hours.left)
    
                                item.classList.remove('loading')
    
                                window.hours = hours
    
                                if(data.status == 'error') {
                                    add_notif({
                                        title: 'Ошибка',
                                        text: 'Час уже арендован другим пользователем',
                                        timeout: 4000
                                    })
                                } else if (data.status == 'expired') {
                                    add_notif({
                                        title: 'Ошибка',
                                        text: 'Дата уже не актуальна',
                                        color: 'red',
                                        timeout: 4000
                                    })
                                } else if (data.status == 'select') {
                                    item.classList.add('selected')
                                    getHas()
                                } else {
                                    item.classList.remove('selected')
                                    getHas()
                                }
    
                                appendHours.textContent = hours
                            })
                        }
                    }
                })
            }
        }
    }

    // prevMonth.addEventListener('click', prev)
    // nextMonth.addEventListener('click', next)

    function getWeek(date, current_month, show_label = false) {
        let day_ms = 86400000
        let day_week = date.getDay()
        let week = []
        let labels = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']

        day_week = day_week == 0 ? day_week = 6 : day_week - 1
        let start = date.getTime() - (day_ms * (day_week + 1))

        for(let i = 1; i < 8; i++) {
            let date = new Date(start + (day_ms * i))
            let month = date.getMonth() + 1
            let current = false
            let dmy = date.dmY()
            let ymd = date.Ymd()
            let label = show_label ? labels[i - 1] : null

            if(month == current_month) {
                current = true
            }

            week.push({date, current, dmy, ymd, label})
        }

        return week
    }

    function getWeeks(year, month) {
        let first_day = new Date([year, month > 9 ? month : '0' + month, '01'].join('-'))

        let first_week = getWeek(first_day, month, true)
        let weeks = [first_week]
        let week_ms = 604800000
        let loop = true

        while(loop) {
            first_day = new Date(first_day.getTime() + week_ms)
            let week = getWeek(first_day, month)

            if(week[0].current) {
                weeks.push(week)
            } else {
                loop = false
            }
        }

        return weeks
    }

}